import React from 'react';

import type { ModalService } from './../ricos-modals';

export const ModalServiceContext = React.createContext<ModalService>(
  null as unknown as ModalService
);
